import React from 'react';
import {SecondaryHeader} from 'generic/HorizontalNavigationComponent/HorizontalNavigationComponent.react';

export default class CreateAssignmentSecondaryHeader extends React.Component {
  render() {
    return (
      <SecondaryHeader
        identity='CreateAssignment'
        links={null}
        leftContent={null}
        rightContent={null}
      />
    );
  }
}
